import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-162238dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title w-100 text-center fw-bold"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title w-100 text-center fw-bold"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_9 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_10 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_12 = {
  key: 1,
  class: "col-lg-12"
}
const _hoisted_13 = {
  key: 2,
  class: "col-lg-12"
}
const _hoisted_14 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_15 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_16 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_17 = { class: "col-lg-12" }
const _hoisted_18 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3" }
const _hoisted_19 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_20 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = { class: "content-break break-spaces text-break" }
const _hoisted_23 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3" }
const _hoisted_24 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_25 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_26 = { class: "col-lg-12" }
const _hoisted_27 = { class: "content-break break-spaces" }
const _hoisted_28 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3" }
const _hoisted_29 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_30 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_31 = { class: "col-lg-12" }
const _hoisted_32 = { class: "content-break break-spaces" }
const _hoisted_33 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3" }
const _hoisted_34 = { class: "text-center fw-bold" }
const _hoisted_35 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import { onMounted, PropType, ref } from 'vue'
import Button from '@/components/button/index.vue'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  props: {
  formData: {
    type: Object,
    default: () => ({
      target: '',
      title: '',
      content: '',
      publication_start_period: '',
      publication_end_period: '',
    }),
  },
  onSubmitMessage: {
    type: Function as PropType<() => void | undefined>,
  },
  disabledButton: Boolean,
},
  setup(__props) {

const route = useRoute()

const checkRoute = ref(false)
onMounted(() => {
  if (route.params?.notification_id) checkRoute.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (checkRoute.value === true)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(_unref(translate)('CF20titleEditANotice')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_unref(translate)('CF20titleCreateANotice')), 1)),
          _hoisted_7
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('CF20targetPerson')), 1),
            _createElementVNode("div", _hoisted_10, [
              (__props.formData.target == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('almunai')), 1))
                : (__props.formData.target == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('CF20enroll')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('CF20adminUser')), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('title')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(__props.formData.title), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('content')), 1),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, _toDisplayString(__props.formData.content), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('CF10startDate')), 1),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(dayjs)(__props.formData.publication_start_period).format('YYYY/MM/DD HH:mm')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(translate)('CF10endDate')), 1),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(dayjs)(__props.formData.publication_end_period).format('YYYY/MM/DD HH:mm')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("span", _hoisted_34, _toDisplayString(checkRoute.value === true ? _unref(translate)('OE53confirmText') : _unref(translate)('ques')), 1)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(Button, {
              title: _unref(translate)('SE40back'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'me-2 fw-bold'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: checkRoute.value === true ? _unref(translate)('update') : _unref(translate)('signUp'),
              type: 'secondary',
              onClick: __props.onSubmitMessage,
              className: 'fw-bold',
              loading: __props.disabledButton,
              disabled: __props.disabledButton
            }, null, 8, ["title", "onClick", "loading", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}
}

})